export default "__VITE_ASSET__CLvRIWwf__"